import moment from 'moment';

/**
 * Extracts the android activity name from the url path.
 *
 * Note: Activity is a term used in Android mobile app development that refers
 * to a similar (but not the same) concept as "page" in web development. To learn more
 * click on the link below go to https://developer.android.com/reference/android/app/Activity.
 */
export function activityNameFromPath(path: string) {
  const parts = path.split('.');
  const lastPart = parts[parts.length - 1];
  return lastPart ?? '';
}

// Indicates whether a session is still online/active.
// When completeSessions=true, all returned sessions are guaranteed to not be online
// If completeSessions=false, assume sessions with recent activity are online, where "recent" is in the past 30 min.
export function isOnline(
  now: moment.Moment,
  time: moment.Moment,
  completeSessions: boolean,
): boolean {
  return !completeSessions && now.diff(time, 'minutes') < 30;
}

// Indicates whether the user is likely to have a "live" session where live follow can be turned on.
// There are 2 cases: (1) there has been activity in the past 30s, or (2) the session started in the past 30min and its
// length is 0, indicating that it was probably instant indexed and therefore hasn't cooked yet.
export function isLive(
  now: moment.Moment,
  lastEventTime: moment.Moment,
  sessionStart: moment.Moment,
  sessionLength: moment.Duration,
  completeSessions: boolean,
): boolean {
  return (
    (!completeSessions && now.diff(lastEventTime, 'seconds') <= 30) ||
    (isOnline(now, sessionStart, completeSessions) && sessionLength.asMilliseconds() == 0)
  );
}
